// extracted by mini-css-extract-plugin
module.exports = {"message-text":"style_message-text__MzgzV"};